import React from "react";
import ClientSignatory from "features/Agreements/AgreementsList/SheetActions/SendForApproval/ClientSignatory";
import { Button } from "semantic-ui-react";
import { Form, useFormField } from "@redriver/cinnamon";
import UserArray from "features/Agreements/AgreementsList/SheetActions/SendForApproval/UserArray";
import { IconButton } from "features/../../../shared/components/buttons";
import { DirectDebitSignatory } from "features/../../../shared/constants/enums";
import Add from "features/../../../shared/assets/black-add.svg";
import { useTranslation } from "react-i18next";

const OptionsStep = ({
  sheetId,
  setTotalDirectDebitSignatories,
  setIncludeSecondClientSignatory,
  includeSecondClientSignatory,
  totalDirectDebitSignatories,
  DirectDebitMandateOptions,
}) => {
  const { t } = useTranslation("agreements");

  const [, setCustomerSignatory2] = useFormField("customerSignatory2");

  const clearCustomerSignatory2 = () => {
    setCustomerSignatory2({
      isNew_customerSignatory2: false,
      authorisedSignatory: null,
      authorisedSignatoryId: null,
      fullName: null,
      position: null,
      email: null,
      phoneNumber: null,
      phoneCountryCode: null,
    });
  };

  return (
    <React.Fragment>
      <ClientSignatory
        field={"customerSignatory1"}
        signatoryDropdownLabel={t(
          "SheetActions.SendForApproval.CustomerSignatory1_Label",
        )}
        sheetId={sheetId}
      />
      <Button
        onClick={() => {
          if (includeSecondClientSignatory) {
            clearCustomerSignatory2();
          }
          setIncludeSecondClientSignatory(!includeSecondClientSignatory);
        }}
        content={t(
          `SheetActions.SendForApproval.${
            includeSecondClientSignatory
              ? "RemoveSecondSignatory"
              : "AddSecondSignatory"
          }`,
        )}
        className="wizard-title-button not-bold"
        style={{ marginBottom: "0.5em" }}
      />

      <Form.If condition={() => includeSecondClientSignatory}>
        <ClientSignatory
          field={"customerSignatory2"}
          signatoryDropdownLabel={t(
            "SheetActions.SendForApproval.CustomerSignatory2_Label",
          )}
          sheetId={sheetId}
        />
      </Form.If>

      {!process.env.TRADE_AS_IPS && (
        <React.Fragment>
          <Form.RadioGroup
            field="directDebitSignatory"
            options={DirectDebitMandateOptions}
            label="Direct Debit Signatory"
          />
          <Form.If
            condition={({ fields }) =>
              fields.directDebitSignatory == DirectDebitSignatory.NewSignatory
            }
          >
            <Form.ArrayAdder
              field="directDebitSignatories"
              arrayKey="id"
              className="wizard-title-button ip-button not-bold"
              as={IconButton}
              icon={Add}
              content={t("SheetActions.SendForApproval.DirectDebitSignatory")}
              populate={() => {
                setTotalDirectDebitSignatories(totalDirectDebitSignatories + 1);
                return {
                  id: Date.now(),
                  name: "",
                  email: "",
                };
              }}
              disabled={totalDirectDebitSignatories >= 2}
            />

            <UserArray
              field="directDebitSignatories"
              onUserRemoved={() =>
                setTotalDirectDebitSignatories(totalDirectDebitSignatories - 1)
              }
            />
          </Form.If>
          <br />
        </React.Fragment>
      )}

      <Form.ArrayAdder
        field="usersToViewBeforeDocumentSigned"
        arrayKey="id"
        className="wizard-title-button ip-button not-bold"
        as={IconButton}
        icon={Add}
        content={t("SheetActions.SendForApproval.ViewBeforeSigned")}
        populate={() => ({
          id: Date.now(),
          name: "",
          email: "",
        })}
      />

      <UserArray field="usersToViewBeforeDocumentSigned" />

      <Form.ArrayAdder
        field="usersToReceiveCopyOfSignedDocument"
        arrayKey="id"
        className="wizard-title-button ip-button not-bold"
        as={IconButton}
        icon={Add}
        content={t("SheetActions.SendForApproval.ReceiveCopyOfSignedDocument")}
        populate={() => ({
          id: Date.now(),
          name: "",
          email: "",
        })}
      />

      <UserArray field="usersToReceiveCopyOfSignedDocument" />
    </React.Fragment>
  );
};
export default OptionsStep;
